<template>
    <div class="form-field form-options">
        <legend class="option-header">
            <span class="option-name">
                {{ t("components.carat") }}:
                <span class="option-swatch-value">
                    {{ minFormatted }} - {{ maxFormatted }}
                </span>
            </span>
        </legend>
        <vue-slider
            class="option-values"
            v-model="value"
            :interval="0.01"
            :min="caratMin"
            :max="caratMax"
            :contained="true"
            style="height: 2px"
        />
    </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import VueSlider from "vue-slider-component";
import "@/styles/slider.css";
import useStore from "@/composables/useStore";
import { useI18n } from "vue-i18n";

export default defineComponent({
    name: "CaratSelect",
    components: {
        VueSlider
    },
    setup() {
        const store = useStore();

        const caratMin = store.computed.caratMin;
        const caratMax = store.computed.caratMax;

        const { t, n } = useI18n();

        const value = computed({
            get() {
                return [
                    store.state.userSelection.caratMin,
                    store.state.userSelection.caratMax
                ];
            },

            set([min, max]: Array<number>) {
                min ? store.actions.setCaratMin(min) : null;
                max ? store.actions.setCaratMax(max) : null;
            }
        });

        const minFormatted = computed(
            () =>
                `${n(store.state.userSelection.caratMin ?? 0)} ${t(
                    "components.ct"
                )}`
        );
        const maxFormatted = computed(
            () =>
                `${n(store.state.userSelection.caratMax ?? 0)} ${t(
                    "components.ct"
                )}`
        );

        return {
            ...useI18n(),
            value,
            minFormatted,
            maxFormatted,
            caratMin,
            caratMax
        };
    }
});
</script>
